import { useGlobalAppState } from '../GlobalAppState';

export const useLastInteractedStoreMachine = () => {
  const { lastInteractedStoreMachineRef } = useGlobalAppState();

  return lastInteractedStoreMachineRef;
};
